// apijs
import http from './../../http.js'

// 院校地址
export const GetProvinceListSchool = data => {
	return http({
		url: "/School/GetProvinceList",
		method: 'get'
	})
};



// 根据院校地址获取列表
export const GetRegSchoolListSchool = data => {
	return http({
		url: "/School/GetRegSchoolList?AI_ProvinceId=" + data,
		method: 'get'
	})
};


//   搜索
export const GetMenuListByContainsName = data => {
	return http({
		url: "/Authoriy/GetMenuListByContainsName?menuName=" + data,
		method: 'get'
	})
};


// 用户授权

export const SetUserPermissions = data => {
	return http({
		url: "/user/SetUserPermissions",
		method: 'post',
		data
	})
};



// 角色不分页

export const AuthoriyGetRoleList = data => {
	return http({
		url: "/Authoriy/GetRoleList",
		method: 'get'
	})
};



// 添加角色
export const AuthoriyRoleInsertOrEdit = data => {
	return http({
		url: "/Authoriy/RoleInsertOrEdit",
		method: 'post',
		data
	})
};
// 删除角色
export const AuthoriyRoleDeleteList = data => {
	return http({
		url: "/Authoriy/RoleDeleteList",
		method: 'post',
		data
	})
};

// 菜单不分页
export const AuthoriyGetMenuList = data => {
	return http({
		url: "/Authoriy/GetMenuList",
		method: 'get',
	})
};


// 权限不分页
export const AuthoriyGetAuthList = data => {
	return http({
		url: "/Authoriy/GetAuthList",
		method: 'get',
	})
};


// 删除菜单
export const AuthoriyMenuDeleteList = data => {
	return http({
		url: "/Authoriy/MenuDeleteList",
		method: 'post',
		data
	})
};

// 批量导入用户

export const setImportUser = data => {
	return http({
		url: "/user/ImportUser",
		method: 'post',
		data
	})
};

export const getPageUserTypeList = data => {
	return http({
		url: '/user/GetPageUserList?pageIndex=' + data.pageIndex + "&pageSize=" + data.pageSize +
			"&ui_userName=" + data.ui_userName + "&si_guid=" + data.si_guid + "&ut_guid=" + data.ut_guid +
			"&rl_guid=" + (data.rl_guid || ""),
		method: 'get'
	})
};
// 用户类型
export const getGetPageUserTypeList = data => {
	return http({
		url: '/UserType/GetPageUserTypeList?pageIndex=' + data.pageIndex + "&pageSize=" + data.pageSize +
			"&ut_typeName=" + data.ut_typeName,
		method: 'get'
	})
};


export const getDelete = data => {
	return http({
		url: '/user/Delete?ui_guid=' + data.ui_guid + "&isDelete=" + data.isDelete,
		method: 'get'
	})
};


export const getUserSingle = data => {
	return http({
		url: '/user/GetUserSingle?ui_guid=' + data,
		method: 'get'
	})
};


export const getEditStatus = data => {
	return http({
		url: '/user/EditStatus?ui_guid=' + data.ui_guid + "&sys_status=" + data.sys_status,
		method: 'get'
	})
};

export const getUpdateUserInfo = data => {
	return http({
		url: "/user/UpdateUserInfo",
		method: 'post',
		data
	})
};

export const getSchoolList = data => {
	return http({
		url: "/School/GetPageSchoolList?pageIndex=" + data.pageIndex + "&pageSize=" + data.pageSize +
			"&si_name_cn=" + data.si_name_cn + "&si_province=" + data.si_province,
		method: 'get'
	})
};

export const DeleteListSchool = data => {
	return http({
		url: "/School/DeleteList",
		method: 'post',
		data
	})
};


export const DeleteSchool = data => {
	return http({
		url: "/School/Delete?si_guid=" + data.si_guid + "&isDelete=" + data.isDelete,
		method: 'get'
	})
};

export const getTrainSingle = data => {
	return http({
		url: "/School/GetTrainSingle?si_guid=" + data,
		method: 'get',
	})
};

export const getInsertOrEdit = data => {
	return http({
		url: "/School/InsertOrEdit",
		method: 'post',
		data
	})
};

// 校园状态

export const getSchoolEditStatus = data => {
	return http({
		url: "/School/EditStatus?si_guid=" + data.si_guid + "&si_status=" + data.si_status,
		method: 'get'
	})
};

// 专业管理

export const getPageProfList = data => {
	return http({
		url: "/Professional/GetPageProfList?pageIndex=" + data.pageIndex + "&pageSize=" + data.pageSize +
			"&pro_name=" + data.pro_name + "&si_guid=" + data.si_guid,
		method: 'get'
	})
};

export const getzyInsertOrEdit = data => {
	return http({
		url: "/Professional/InsertOrEdit",
		method: 'post',
		data
	})
};

export const getzyTrainSingle = data => {
	return http({
		url: "/Professional/GetTrainSingle?pro_guid=" + data,
		method: 'get'
	})
};


export const getzyDelete = data => {
	return http({
		url: "/Professional/Delete?pro_guid=" + data,
		method: 'get',
	})
};

// 菜单管理

export const getPcdageMenuList = data => {
	return http({
		url: "/Authoriy/GetPageMenuList?pageIndex=" + data.pageIndex + "&pageSize=" + data.pageSize +
			"&mu_parentGuid=" + data.mu_parentGuid + "&mu_name_cn=" + data.mu_name_cn,
		method: 'get',
	})
};


export const getcdMenuSingle = data => {
	return http({
		url: "/Authoriy/GetMenuSingle?mu_guid=" + data,
		method: 'get'
	})
};

// 添加菜单

export const getMenuInsertOrEdit = data => {
	return http({
		url: "/Authoriy/MenuInsertOrEdit",
		method: 'post',
		data
	})
};

// 部门


// 角色
export const GetjsPageRoleList = data => {
	return http({
		url: "/Authoriy/GetPageRoleList?pageIndex=" + data.pageIndex + "&pageSize=" + data.pageSize +
			"&rl_parentGuid=" + data.rl_parentGuid + "&rl_name=" + data.rl_name,
		method: 'get'
	})
};

// 权限管理
export const GetqxPageAuthList = data => {
	return http({
		url: "/Authoriy/GetPageAuthList?pageIndex=" + data.pageIndex + "&pageSize=" + data.pageSize +
			"&au_parentGuid=" + data.au_parentGuid + "&au_name=" + data.au_name,
		method: 'get'
	})
};

export const GetqxAuthInsertOrEdit = data => {
	return http({
		url: "/Authoriy/AuthInsertOrEdit",
		method: 'post',
		data
	})
};

export const GetqxAuthDelete = data => {
	return http({
		url: "/Authoriy/AuthDelete?au_guid=" + data,
		method: 'get'
	})
};

// 班级


export const GetbjPageClassList = data => {
	return http({
		url: "/ClassInfo/GetPageClassList?pageIndex=" + data.pageIndex + "&pageSize=" + data.pageSize +
			"&cla_name=" + data.cla_name + "&si_guid=" + data.si_guid,
		method: 'get'
	})
};
// 实训室分页
export const TrainGetPageTrainList = data => {
	return http({
		url: "/Train/GetPageTrainList?pageIndex=" + data.pageIndex + "&pageSize=" + data.pageSize +
			"&tr_name=" + data.tr_name + "&si_guid=" + data.si_guid,
		method: 'get'
	})
};

// 
// 实训室不分页
export const TrainGetTrainList = data => {
	return http({
		url: "/Train/GetTrainList?si_guid=" + data,
		method: 'get'
	})
};
// 班级不分页
export const ClassInfoGetClassList = data => {
	return http({
		url: "/ClassInfo/GetClassList?si_guid=" + data,
		method: 'get'
	})
};

// 根据专业获取班级

export const GetProClassList= data => {
	return http({
		url: "/ClassInfo/GetProClassList?pro_guid=" + data,
		method: 'get'
	})
};

// 根据学校和班级获取专业列表(不分页

export const GetProfListByclassid = data => {
	// console.log("专业不分页",data)
	return http({
		url: "/Professional/GetProfListByclassid?si_guid=" + data.si_guid + "&cla_guid=" + data.cla_guid,
		method: 'get'
	})
};

// 获取学校参数信息

export const GetParameterList = data => {
	return http({
		url: "/Parameter/GetParameterList?si_guid=" + data,
		method: 'get'
	})
};

// 保存学校参数
export const ParameterInsertOrEdit = data => {
	return http({
		url: "/Parameter/InsertOrEdit",
		method: 'post',
		data
	})
};


// 院校不分页

export const GetbjGetSchoolList = data => {
	return http({
		url: "/School/GetSchoolList",
		method: 'get'
	})
};

// 类型不分页

export const GetUserTypeList = data => {
	return http({
		url: "/UserType/GetUserTypeList",
		method: 'get'
	})
};

export const GetbjInsertOrEdit = data => {
	return http({
		url: "/ClassInfo/InsertOrEdit",
		method: 'post',
		data
	})
};


export const GetbjDelete = data => {
	return http({
		url: "/ClassInfo/Delete?cla_guid=" + data,
		method: 'get'
	})
};

// 专业列表

export const GetzyProfList = data => {
	return http({
		url: "/Professional/GetProfList?si_guid=" + data,
		method: 'get'
	})
};



export const FeedBackInsertOrEdit = data => {
	return http({
		url: "/FeedBack/InsertOrEdit",
		method: 'post',
		data
	})
};

export const GetFeedBackListIsComplete = data => {
	return http({
		url: "/FeedBack/GetFeedBackListIsComplete?iscomplete=" + data,
		method: 'get'
	})
};

export const GetUserSelect = data => {
	return http({
		url: "/user/GetUserSelect?pageIndex=" + data.pageIndex +
			`&pageSize=${data.pageSize}&ui_userName=${data.ui_userName}&si_guid=${data.si_guid}&ut_guid=${data.ut_guid}`,
		method: 'get'
	})
};